import React, { useRef } from "react";
import { Grid, Typography, Box, Backdrop } from "@material-ui/core";
import { useFormik } from "formik";
import moment from "moment";
import { useDispatch } from "react-redux";
import CommonButton from "src/components/CommonButton/CommonButton";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";
import { useStyles } from "../style";
import * as Yup from "yup";
import { getPrintFile } from "src/app-redux/common-actions";
import { useAppSelector } from "src/app-redux/hooks";
import { loader as gateEntryLoader } from "src/app-redux/gate-entry/gateEntrySlice";
import CommonLoader from "src/components/Loader/CommonLoader";

export function DailyCollectionReport() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const printLoader = useAppSelector(gateEntryLoader);
  const datePickerRef: any = useRef(null);

  const validationSchema = Yup.object().shape({
    reportDate: Yup.string().required("This field is required"),
  });

  const formik = useFormik({
    initialValues: {
      reportDate: moment(new Date().setHours(0, 0, 0, 0)).format("YYYY-MM-DDTHH:mm"),
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const fileMetaData = {
        url: `${
          process.env.REACT_APP_API_URL
        }/get-daily_revenue-report?reportDate=${encodeURIComponent(values.reportDate)}`,
        contentType: ".pdf",
        fileName: "Daily-Collection-Report.pdf",
      };
      await dispatch(getPrintFile(fileMetaData, dispatch));
    },
  });

  return (
    <>
      <Backdrop className={classes.backdrop} open={printLoader}>
        <CommonLoader />
      </Backdrop>
      <Grid container direction="row" justifyContent="space-between" style={{ paddingTop: "10px" }}>
        <Typography className={classes.pageSubHeading}>Daily Collection Report</Typography>
        <Grid item xs={12} className={classes.outer} container direction="row">
          <Grid item xs={12} md={5}>
            <Box>
              <CommonTextFieldDate
                label={"Date"}
                name={"reportDate"}
                cssClassName="customTextField"
                value={formik.values.reportDate}
                datePickerRef={datePickerRef}
                onChange={(e: any) => {
                  formik.setFieldValue("reportDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                }}
                error={formik.touched.reportDate && Boolean(formik.errors.reportDate)}
                helperText={formik.touched.reportDate && formik.errors.reportDate}
                maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                required
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                marginLeft: { xs: 0, md: "10px" },
                marginTop: { xs: "10px", md: 0 },
              }}
            ></Box>
          </Grid>
          <Grid item xs={12} md={2}>
            <Box
              sx={{
                marginLeft: { xs: 0, md: "10px" },
                marginTop: { xs: "10px", md: 0 },
              }}
            >
              <CommonButton
                isGreen
                cssClass={classes.checkButton}
                onClick={() => formik.submitForm()}
              >
                Print Report
              </CommonButton>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
